import React from 'react'
import classes from './StepControls.module.scss'
import { useTemplateStepsContext } from '@/features/templates'
import Button from '@/components/ui/Buttons/Button'

export type StepControlsProps = {
  disabled?: boolean
}

export const StepControls = ({ disabled = false }: StepControlsProps) => {
  const { currentStep, setCurrentStep } = useTemplateStepsContext()

  return (
    <div className={'d-flex gap-2 justify-content-between'}>
      {currentStep > 0 ? (
        <Button onClick={() => setCurrentStep((currentStep) => currentStep - 1)} color={'neutral'}>
          Back
        </Button>
      ) : (
        <div />
      )}
      <Button onClick={() => setCurrentStep((currentStep) => currentStep + 1)} disabled={disabled}>
        Next
      </Button>
    </div>
  )
}
